export function gaEvent(name: string, params: Record<string, any> = {}) {
  if (typeof window === 'undefined') return
  const g = (window as any).gtag
  if (typeof g !== 'function') return
  g('event', name, params)
}

